import { AdminNotification } from '../types';
import { appConfig } from '../config/appConfig';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:4000/api';

const getAdminToken = (): string => {
  return btoa(`${appConfig.admin.username}:${appConfig.admin.password}`);
};

const getAdminHeaders = () => ({
  Authorization: `Bearer ${getAdminToken()}`,
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export const fetchUnreadNotifications = async (): Promise<AdminNotification[]> => {
  const response = await fetch(`${API_BASE_URL}/notifications?unread=true`, {
    headers: getAdminHeaders(),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Authentication failed. Please check admin credentials.');
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  return data.items || [];
};

export const markNotificationsRead = async (): Promise<number> => {
  const response = await fetch(`${API_BASE_URL}/notifications/mark-read`, {
    method: 'POST',
    headers: getAdminHeaders(),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Authentication failed. Please check admin credentials.');
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  return data.marked || 0;
};
